import { render, staticRenderFns } from "./OrderDetailsContainer.vue?vue&type=template&id=ef43d42a&"
import script from "./OrderDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports